import getCookieByName from '../helpers/getCookieByName'

function parseBusLocale({ state }) {
  const busCookie = getCookieByName('busLocale')
  let currentLocale = null
  if (busCookie) {
    currentLocale = busCookie
  } else {
     const culture = navigator.language
     if (culture) {
       currentLocale = culture.split('-')[0]
     }
  }
  const { locales } = state.get('client')
  const locale = locales.reduce((acc, locale) => {
    if (locale === currentLocale) {
      acc = locale
     }
     return acc
  }, null)

  if (locale) {
   state.set('client.selectedLocale', locale)
  }
}

export default parseBusLocale



// WEBPACK FOOTER //
// ./src/modules/app/actions/parseBusLocale.js